import normalizeErrors from "../normalizeErrors";

/**
 * Extract a single user-facing message from a Plaintr / DRF error payload.
 */
export default function parseApiErrorMessage(errorBody, fallback) {
  if (!errorBody) {
    return fallback;
  }

  if (typeof errorBody === "string") {
    return errorBody;
  }

  if (typeof errorBody.detail === "string") {
    return errorBody.detail;
  }

  if (typeof errorBody.error === "string") {
    return errorBody.error;
  }

  if (typeof errorBody.message === "string") {
    return errorBody.message;
  }

  const source =
    errorBody.detail && typeof errorBody.detail === "object"
      ? errorBody.detail
      : errorBody;

  const messages = normalizeErrors(source);
  return messages[0] || fallback;
}

/**
 * Build a standard { success: false, message, status } from a failed fetch Response.
 */
export async function apiFailureFromResponse(response, fallbackMessage) {
  const body = await response.json().catch(() => ({}));

  return {
    success: false,
    message: parseApiErrorMessage(body, fallbackMessage),
    status: response.status,
  };
}

/**
 * Build a standard failure result without parsing a response body.
 */
export function apiFailure(message, status) {
  return {
    success: false,
    message,
    ...(status !== undefined ? { status } : {}),
  };
}
